import { useEffect, useRef } from "react";
import '../animate.css';

const CustomMarker = ({ position, map, isNewDelivery, onClick }) => {
    const markerRef = useRef(null);
    const waveRef = useRef(null);
    const overlayRef = useRef(null);

    useEffect(() => {
        if (!window.google || !map) return;

        const overlay = new window.google.maps.OverlayView();

        overlay.onAdd = function () {
            console.log('Overlay Added');
            const div = document.createElement("div");
            div.className = "custom-marker";

            // Log position
            console.log('Custom Marker Position:', position);

            if (isNewDelivery) {
                const wave = document.createElement("div");
                wave.className = "wave-effect";
                div.appendChild(wave);
                waveRef.current = wave;
            }

            // Add click event listener to the custom marker
            div.addEventListener('click', () => {
                console.log('Marker clicked at:', position);
                if (onClick) {
                    console.log('Triggering onClick...');
                    onClick();  // Trigger the onClick function passed from parent
                }
            });

            markerRef.current = div;
            this.getPanes().overlayLayer.appendChild(div);

            // Set the cursor style to pointer for hover
            div.style.cursor = 'pointer';
        };

        overlay.draw = function () {
            if (!markerRef.current) return;
            const projection = this.getProjection();
            const pos = projection.fromLatLngToDivPixel(new window.google.maps.LatLng(position.lat, position.lng));

            if (pos) {
                markerRef.current.style.left = `${pos.x - 10}px`;
                markerRef.current.style.top = `${pos.y - 10}px`;
                markerRef.current.style.position = "absolute";
            }
        };

        overlay.onRemove = function () {
            if (markerRef.current) {
                markerRef.current.parentNode.removeChild(markerRef.current);
                if (waveRef.current) {
                    waveRef.current.parentNode.removeChild(waveRef.current);  // Remove wave element
                }
            }
            markerRef.current = null;
            waveRef.current = null;
        };

        overlay.setMap(map);
        overlayRef.current = overlay;

        return () => {
            overlay.setMap(null);
        };
    }, [position, isNewDelivery, map, onClick]);

    return null;
};

export default CustomMarker;
